module.exports = __webpack_public_path__ + "img/medicamento-icon.b6aee931.svg";